import styled, { createGlobalStyle } from "styled-components";
import { theme } from "@sqymagma/theme";

const JoditGlobalStyles = createGlobalStyle`
  .jodit * {
    font-family: ${theme("fontFamily.primary")} !important;
  }

  .jodit-popup {
    border-radius: ${theme("radii.m")};
    box-shadow: ${theme("shadows.tiny")};
    border: 1px solid ${theme("colors.line07")};
    overflow: hidden;

    .jodit-popup__content {
      background-color: ${theme("colors.senaryBackground")};

      .jodit-toolbar-editor-collection {
        background: ${theme("colors.senaryBackground")};
      }

      .jodit-toolbar-editor-collection_mode_horizontal:after {
        display: none;
      }

      .jodit-toolbar-button {
        &[data-ref="brush"],
        &[data-ref="pencil"],
        &[data-ref="valign"],
        &[data-ref="left"],
        &[data-ref="file"] {
          display: none;
        }
      }
    }
  }

  .jodit-dialog__header {
    background-color: ${theme("colors.secondaryBackground")};
    color: ${theme("colors.text02")};

    .jodit-toolbar-button__button:hover:not([disabled]) {
      background-color: ${theme("colors.interactive01Hover")};
    }
  }

  .jodit-dialog__header-title {
    ${theme("textStyle.headings")};
  }

  .jodit-toolbar-collection .jodit-toolbar-button {
    zoom: 0.6;
    background-color: ${theme("colors.tertiaryBackground")};
    border-radius: ${theme("radii.circle")};
    aspect-ratio: 1;
    border: none;
    
    svg {
      zoom: 0.8;
      fill: ${theme("colors.text01")} !important;
    }
  }

  .jodit-dialog__content {
    ${theme("textStyle.body")};
  }

  .jodit-ui-button:not([disabled]) {
    ${theme("textStyle.button")};
    background-color: ${theme("colors.secondaryBackground")};
    color: ${theme("colors.text02")};
  }

  .jodit-ui-button:hover:not([disabled]),
  .jodit-ui-button_variant_primary:hover:not([disabled]){
    background-color: ${theme("colors.interactive01Hover")};
    color: ${theme("colors.text02")};
  }

  .jodit-ui-button:active:not([disabled]),
  .jodit-ui-button_variant_primary:active:not([disabled]) {
    background-color: ${theme("colors.interactive01Hover")};
    color: ${theme("colors.text02")};
  }

  .jodit-ui-button:focus-visible:not([disabled]) {
    background-color: ${theme("colors.secondaryBackground")};
    color: ${theme("colors.text02")};
  }

  .jodit-ui-button:focus:not([disabled]),
  .jodit-ui-button_variant_primary:focus:not([disabled]) {
    outline: none;
  }

  .jodit-ui-input__wrapper,
  .jodit-ui-input__input {
    border-radius: ${theme("radii.s")};
    background-color: ${theme("colors.senaryBackground")};
    border-color: ${theme("colors.line07")};
    color: ${theme("colors.text01")};
    &::selection{
      background: ${theme("colors.brand06")};
    }
  }

  .jodit-ui-input_focused_true .jodit-ui-input__wrapper {
    border-color: ${theme("colors.brand01")};
  }

  .jodit-toolbar-button__icon svg {
    fill: ${theme("colors.text03")} !important;
    stroke: none;
  }

  .jodit-toolbar-button__button:hover:not([disabled]) {
    background-color: ${theme("colors.quaternaryBackground")};
  }

  .jodit-toolbar-button__button[aria-pressed=true]:not([disabled]) {
    background-color: ${theme("colors.quaternaryBackground")};
  }

  .jodit-toolbar-button_with-trigger_true:hover:not([disabled]) {
    border-color: ${theme("colors.line07")};
  }

  .jodit-toolbar-button__trigger:hover:not([disabled]) {
    background-color: ${theme("colors.quaternaryBackground")};
  }

  .jodit-toolbar-button__trigger {
    fill: ${theme("colors.text03")};
  }

  .jodit-dialog__panel{
    border-radius: ${theme("radii.m")};
    box-shadow: ${theme("shadows.big")};
    border: none;
    background-color: ${theme("colors.senaryBackground")};
    overflow: hidden;
    resize: none;
  }

  .jodit-dialog_prompt {
    max-width: 100%;
  }

  .jodit-dialog_resizable_true .jodit-dialog__resizer {
    display: none;
  }
`;

const EditorWrapper = styled.div`
  position: relative;

  .jodit__container {
    background-color: ${(p) => p.theme.colors.senaryBackground};
    border: 1px solid ${(p) => p.theme.colors.line07};
    overflow: hidden;
    font-family: ${(p) => p.theme.fontFamily.primary};

    .jodit-toolbar__box {
      background-color: ${(p) => p.theme.colors.senaryBackground};
      border-color: ${(p) => p.theme.colors.line07};
    }

    .jodit-toolbar-editor-collection:after {
      background-color: ${(p) => p.theme.colors.senaryBackground};
    }

    .jodit-placeholder {
      ${theme("textStyle.body")};
      color: ${(p) => p.theme.colors.disabled01};
    }

    .jodit-ui-separator {
      border-color: ${(p) => p.theme.colors.line07};
    }
  }

  .jodit__editor {
    ${theme("textStyle.body")};
    color: ${(p) => p.theme.colors.text01};
    background-color: ${(p) => p.theme.colors.senaryBackground};

    & a {
      color: ${(p) => p.theme.colors.link01};
      text-decoration: underline;
    }

    & *::selection {
      background: ${(p) => p.theme.colors.brand06};
      color: ${(p) => p.theme.colors.text01};
    }
  }

  .jodit-resizer {
    outline-color: ${(p) => `${p.theme.colors.brand01}bb`};
    & > div {
      background-color: ${(p) => p.theme.colors.brand01};
      border-radius: 2px;
    }
  }
`;

const GifSearch = styled.div`
  position: absolute;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${(p) => p.theme.colors.senaryBackground};
  border-radius: ${(p) => p.theme.radii.m};
  padding: ${(p) => p.theme.spacing.xs};
  box-shadow: ${(p) => p.theme.shadows.tiny};
  border: 1px solid ${(p) => p.theme.colors.line07};

  .reactGiphySearchbox-searchForm-input {
    ${theme("textStyle.bodyInline")};
    color: ${(p) => p.theme.colors.text01};
    background-color: ${(p) => p.theme.colors.senaryBackground};
    border: none;
    border-bottom: 2px solid ${(p) => p.theme.colors.line02};
    &:hover {
      border-color: ${(p) => p.theme.colors.brand01};
    }
    &:focus {
      border-color: ${(p) => p.theme.colors.line02};
    }
  }

  .reactGiphySearchbox-listWrapper::-webkit-scrollbar {
    width: 0;
  }

  .react-giphy-searchbox-list-item {
    border-radius: 4px;
    overflow: hidden;
  }

  .reactGiphySearchbox-message {
    ${theme("textStyle.body")};
  }
`;

const LoaderWrapper = styled.div<{ $visible: boolean }>`
  visibility: ${(p) => (p.$visible ? "visible" : "hidden")};
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1000;
`;

const LoaderBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(p) => p.theme.colors.senaryBackground};
  opacity: 0.4;
`;

const Loader = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export {
  GifSearch,
  EditorWrapper,
  JoditGlobalStyles,
  LoaderWrapper,
  LoaderBackground,
  Loader,
};
